import React, { useEffect, useState } from "react";
import "./admincontrols.css";

const PCBRequestsTable = () => {
  const [data, setData] = useState([]);
  const [config, setConfig] = useState(null);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  
  useEffect(() => {
    if (!config) return;

    const fetchData = async () => {
      try {
        const res = await fetch(`${config.BASE_URL}${config.GET_PCB_REQUESTS}`, {
          method: "POST",   
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify() 
        });

        const result = await res.json();
        if (result.success) {
          setData(result.data);
        } else {
          alert(result.message || "Failed to fetch PCB requests");
        }
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    fetchData();
  }, [config]);

  return (
    <div className="pcb-table-container">
      <h2>PCB Design Requests</h2>
      <table className="pcb-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Company</th>
            <th>Gerber File</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((row, index) => (
              <tr key={index}>
                <td>{row.name}</td>
                <td>{row.mail}</td>
                <td>{row.company}</td>
                <td>
                  <a
                    href={`/temp_media/temp_gerber_files/${row.gerber_file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {row.gerber_file}
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No records found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PCBRequestsTable;
